import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React, { useState } from "react";
import { Typography, ShadowContainer, makeStyles, useAlert, Alert } from "componentLibrary";
import DragDropSortableFields from "componentLibrary/CustomizeColumns/DragDropSortableFields";
import CustomizeTransactionColumns from "componentLibrary/CustomizeColumns/CustomizeTransactionColumns";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var searchAndSortStyles = makeStyles(function (theme) {
  return {
    header: {
      marginBottom: "32px"
    },
    bodyWrapper: function bodyWrapper(_ref) {
      var isPhone = _ref.isPhone;
      return {
        display: "flex",
        flexDirection: isPhone ? "column" : "row",
        gap: isPhone ? "16px" : "24px",
        height: isPhone ? undefined : "100%"
      };
    },
    leftSection: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      height: "100%",
      marginBottom: function marginBottom(_ref2) {
        var isPhone = _ref2.isPhone;
        return isPhone ? "24px" : "0px";
      }
    },
    rightSection: {
      width: "100%",
      height: "100%"
    },
    scrollContainer: {
      width: "100%",
      height: "100%",
      flexGrow: 1,
      overflow: "scroll"
    },
    selectedColumnsContainer: {
      width: "100%",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    selectedColumnsHeader: {
      marginBottom: "16px",
      flexGrow: 0
    }
  };
});
var CustomizeColumnsView = function CustomizeColumnsView(_ref3) {
  var transactionColumns = _ref3.transactionColumns,
    customColumns = _ref3.customColumns,
    selectedColumns = _ref3.selectedColumns,
    setSelectedColumns = _ref3.setSelectedColumns,
    isPhone = _ref3.isPhone,
    editingColumn = _ref3.editingColumn,
    setEditingColumn = _ref3.setEditingColumn,
    organizationId = _ref3.organizationId;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchBy = _useState2[0],
    setSearchBy = _useState2[1];
  var classes = searchAndSortStyles({
    isPhone: isPhone
  });
  var _useAlert = useAlert(),
    showAlert = _useAlert.showAlert;
  var _React$useState = React.useState(_toConsumableArray(customColumns === null || customColumns === void 0 ? void 0 : _mapInstanceProperty(customColumns).call(customColumns, function (column) {
      return _objectSpread(_objectSpread({
        label: column.name,
        isChecked: _someInstanceProperty(selectedColumns).call(selectedColumns, function (selected) {
          return selected.id === column.id;
        }),
        isDisabled: false
      }, column), {}, {
        isCustomField: true
      });
    }))),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    customColumnsState = _React$useState2[0],
    setCustomColumnsState = _React$useState2[1];
  var onChangeSearchValue = function onChangeSearchValue(event) {
    var _event$target;
    setSearchBy(event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
  };
  var getColumnById = function getColumnById(columnId) {
    var _context;
    var allColumns = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(transactionColumns), _toConsumableArray(customColumnsState));
    return _findInstanceProperty(allColumns).call(allColumns, function (column) {
      return column.id === columnId;
    }) || null;
  };
  var handleDragableChange = function handleDragableChange(event) {
    var value = event.target.value;
    setSelectedColumns(value);
  };
  var onCheckboxFilterChange = function onCheckboxFilterChange(event) {
    var isChecked = event.target.checked;
    var value = event.target.value;
    var column = getColumnById(value);
    if (column) {
      var columnConfig = _objectSpread({}, column);
      columnConfig.isDisabled = !columnConfig.isOrderable; // Disable drag & drop if it's not orderable
      columnConfig.isRemovable = !columnConfig.isDefault; // Allow removal only if it's not default

      setSelectedColumns(function (prev) {
        if (isChecked) {
          var _context2;
          return _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(prev), [columnConfig]);
        }
        return _filterInstanceProperty(prev).call(prev, function (col) {
          return col.id !== value;
        });
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Alert, {}), /*#__PURE__*/_jsxs("div", {
      className: classes.bodyWrapper,
      children: [isPhone ? /*#__PURE__*/_jsx(CustomizeTransactionColumns, {
        transactionColumns: transactionColumns,
        selectedColumns: selectedColumns,
        setSelectedColumns: setSelectedColumns,
        editingColumn: editingColumn,
        setEditingColumn: setEditingColumn,
        organizationId: organizationId,
        customColumns: customColumns,
        customColumnsState: customColumnsState,
        setCustomColumnsState: setCustomColumnsState,
        searchBy: searchBy,
        onChangeSearchValue: onChangeSearchValue,
        onCheckboxFilterChange: onCheckboxFilterChange,
        showAlert: showAlert,
        isPhone: isPhone
      }) : /*#__PURE__*/_jsx("div", {
        className: classes.leftSection,
        children: /*#__PURE__*/_jsx(CustomizeTransactionColumns, {
          transactionColumns: transactionColumns,
          selectedColumns: selectedColumns,
          setSelectedColumns: setSelectedColumns,
          editingColumn: editingColumn,
          setEditingColumn: setEditingColumn,
          organizationId: organizationId,
          customColumns: customColumns,
          customColumnsState: customColumnsState,
          setCustomColumnsState: setCustomColumnsState,
          searchBy: searchBy,
          onChangeSearchValue: onChangeSearchValue,
          onCheckboxFilterChange: onCheckboxFilterChange,
          showAlert: showAlert,
          isPhone: isPhone
        })
      }), /*#__PURE__*/_jsxs(ShadowContainer, {
        className: classes.selectedColumnsContainer,
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.selectedColumnsHeader,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            weight: "semibold",
            children: "Selected Columns (".concat(selectedColumns === null || selectedColumns === void 0 ? void 0 : selectedColumns.length, ")")
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classes.scrollContainer,
          children: /*#__PURE__*/_jsx(DragDropSortableFields, {
            data: selectedColumns,
            onChange: handleDragableChange,
            name: "SelectedColumns",
            useRedesign: true,
            disabled: editingColumn !== false
          })
        })]
      })]
    })]
  });
};
export default CustomizeColumnsView;